import { datasetAPI } from 'api/dataset';
import { DatasetDto } from 'dto/dataset';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
  enabled?: boolean;
  onSuccess?: (data: DatasetDto) => void;
};

export function useFindOneDataset(props: PropsType) {
  const query = useQuery({
    queryKey: [QUERY_KEY.FIND_ONE_DATASET, props.id],
    queryFn: () => datasetAPI.findOne(props.id),
    enabled: !!props.id || props.enabled,
    onSuccess: props.onSuccess,
  });

  return query;
}
